(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["mall-fe-vss-404"] = factory();
	else
		root["mall-fe-vss-404"] = factory();
})(window, function() {
return 